import React from "react";

// Pentatonic: Solid backgrounds only, no gradients or animated shapes
const BackgroundShapes = () => {
  return (
    <div className="fixed inset-0 w-screen h-screen -z-10 bg-penta-grey-light">
      {/* Pentatonic brand: clean, solid backgrounds */}
    </div>
  );
};

export default BackgroundShapes;
